import lottie from "lottie-web-light"

export default function animateJSON(
  containerId: string,
  animationData: object,
  loop = 1,
  onComplete: (() => void) | null = null
) {
  const $container = document.getElementById(containerId)
  if ($container) {
    $container.innerHTML = ""
    const anim = lottie.loadAnimation({
      container: $container,
      renderer: "svg",
      loop,
      autoplay: false,
      animationData: JSON.parse(JSON.stringify(animationData)),
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    })
    onComplete && anim.addEventListener("complete", onComplete)
    return anim
  }
}
